// extracted by mini-css-extract-plugin
export default {"form_container":"style_form_container__61Emi","formGroup":"style_formGroup__xpXVt","title":"style_title__guRgh","button":"style_button__30wLV"};